import {
  List,
  Datagrid,
  TextField,
  EditButton,
  TopToolbar,
  CreateButton,
  FunctionField,
  ExportButton,
  TextInput,
  DateField,
} from 'react-admin';
import { Card, CardContent, Button, Box } from '@mui/material';
import DeleteWithConfirmButton from "../../components/DeleteWithConfirmButton.tsx";
import UploadButton from '../../components/UploadButton.tsx';
import TemplateDownloadButton from '../../components/TemplateDownloadButton.tsx';
import BarChartIcon from '@mui/icons-material/BarChart';
import { useNavigate } from 'react-router-dom';
import { useNotify, useRedirect, useRefresh } from 'react-admin';
import { BulkDeleteButton } from 'react-admin';

const CustomBulkActionButtons = () => (
  <>
    <BulkDeleteButton
      label="Delete Selected"

    />
  </>
);

const salesFilters = [
  <TextInput sx={{
    '& .MuiInputBase-input': {
      height: 40,      // 输入框高度
      padding: '6px 12px',
      fontSize: 14,
      lineHeight: '40px', // 使文字垂直居中
    },
    minHeight: 36,      // 整体高度
    marginBottom: '16px',
  }} label="Search For Product Id" source="productId" alwaysOn resettable />,

];
const ListActions = () => {
  const refresh = useRefresh();
  const notify = useNotify();
  const redirect = useRedirect();
  const navigate = useNavigate();
  return (
    <TopToolbar sx={{ marginBottom: '16px', }}>
      <Button
        color="primary"
        startIcon={<BarChartIcon />}
        sx={{
          textTransform: 'capitalize', minWidth: 'auto', marginRight: 0, '& span': {

            marginTop: '0px',
            marginRight: '2px',
          }
        }}
        onClick={() => navigate('/sales/chart')}
      >
        <span>Chart</span>
      </Button>
      <TemplateDownloadButton href="/templates/sales_template.csv" />
      <UploadButton resource="sales" onSuccess={() => {
        redirect('/sales');
        setTimeout(() => refresh(), 10);
      }} />
      <ExportButton sx={{
        textTransform: 'capitalize', '&.css-istbiy-MuiButtonBase-root-MuiButton-root': {
          marginLeft: '0 !important', // 强制覆盖
        }, top: '-5px', '& span': {

          marginRight: '2px',

        }, ml: 0,
      }} />
      <CreateButton label="New Sales" sx={{
        top: '-5px', '& span': {

          marginRight: '2px',
        }
      }} />
    </TopToolbar>
  );
};

const ActionButtons = ({ record }: { record?: any }) => {
  const navigate = useNavigate();
  if (!record) return null;
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', width: '100%' }}>
      {/* <Button
        color="primary"
        size="small"
        startIcon={<BarChartIcon />}
        sx={{ textTransform: 'capitalize', minWidth: 'auto' }}
        onClick={e => { e.stopPropagation(); navigate(`/sales/${record.id}/chart`); }}
      >
        Chart
      </Button> */}
      <EditButton record={record} sx={{
        textTransform: 'capitalize', '& span': {

          marginRight: '2px',

        }
      }} />
      <DeleteWithConfirmButton record={record} resource="sales" />
    </div>
  );
};
const SalesList = (props) => (

  <List
    sx={{ marginTop: '20px', padding: '0 16px' }}
    empty={false}
    filters={salesFilters}
    {...props} actions={<ListActions />}>


    <Datagrid rowClick={false} isRowSelectable={() => true} bulkActionButtons={<BulkDeleteButton label="批量删除" />}

      sx={{

        '& .RaDatagrid-headerCell': {
          textAlign: 'center',
        },
        '& .RaDatagrid-rowCell': {
          textAlign: 'center',
        },
      }}>
      <TextField source="id" label="Sales id" />


      <TextField source="product.productId" label="ProductId" />
      <TextField source="product.name" label="ProductName" />
      <TextField source="quantity" label="quantity" />
      <TextField source="unit" label="Unit" />
      <DateField source="orderDate" label="OrderDate" />
      <FunctionField label="Operations" render={record => <ActionButtons record={record} />} />

    </Datagrid>


  </List >
);
// const SalesList = () => {
//   return (
//     <div style={{ padding: '24px' }}>
//       <Card elevation={3} sx={{ borderRadius: 3, padding: 2 }}>
//         <CardContent>
//           <List
//             resource="sales"
//             empty={false}
//             title="Sales 列表"
//             actions={<ListActions />}
//             perPage={25}
//           >
//             <div style={{ overflowX: 'auto' }}>
//               <Datagrid rowClick="edit" sx={{ minWidth: 900 }}>
//                 <TextField source="id" label="Sales id" />
//                 <TextField source="product.productId" label="产品编号" />
//                 <TextField source="product.name" label="产品" />
//                 <TextField source="quantity" label="" />
//                 <TextField source="unit" label="单位" />
//                 <TextField source="orderDate" label="订单日期" />
//                 <FunctionField label="操作" render={record => <ActionButtons record={record} />} />
//               </Datagrid>
//             </div>
//           </List>
//         </CardContent>
//       </Card>
//     </div>
//   );
// };

export default SalesList;
